/**
 * lib/tests.js — Test Builder API wrappers (Phase 118.A.1).
 */
import { api } from "./api";

export const generateTest = (body) =>
  api.post("/tests", body).then((r) => r.data);

export const getTest = (testId) =>
  api.get(`/tests/${testId}`).then((r) => r.data);

export const saveTest = (testId, body) =>
  api.put(`/tests/${testId}`, body).then((r) => r.data);

export const regenerateTest = (testId) =>
  api.post(`/tests/${testId}/regenerate`).then((r) => r.data);

export const markTest = (testId, body) =>
  api.post(`/tests/${testId}/mark`, body).then((r) => r.data);

export const listTestResults = (testId) =>
  api.get(`/tests/${testId}/results`).then((r) => r.data?.results || []);

export const suggestScore = (testId, body) =>
  api.post(`/tests/${testId}/suggest-score`, body).then((r) => r.data);

export const QUESTION_TYPES = [
  { key: "multiple_choice", label: "Multiple choice", hint: "4 options, single correct" },
  { key: "true_false", label: "True / False" },
  { key: "matching", label: "Matching", hint: "left prompts ↔ right answers" },
  { key: "short_answer", label: "Short answer", hint: "1-3 sentences" },
  { key: "long_answer", label: "Long answer", hint: "extended response" },
  { key: "labeling", label: "Labeling", hint: "diagram + label list" },
];

export const ACHIEVEMENT_CATEGORIES = [
  "Knowledge",
  "Thinking",
  "Communication",
  "Application",
];
